// src/api.js
const BASE = process.env.REACT_APP_API_BASE || '';

async function req(method, path, body) {
  const opts = {
    method,
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
  };
  if (body !== undefined) opts.body = JSON.stringify(body);
  let res;
  try {
    res = await fetch(BASE + path, opts);
  } catch (e) {
    return { ok: false, status: 0, data: { error: 'Network error' } };
  }
  const ct = res.headers.get('content-type') || '';
  if (!ct.includes('application/json')) {
    return { ok: false, status: res.status, data: { error: 'not_authenticated' }, notAuth: true };
  }
  const text = await res.text();
  try {
    return { ok: res.ok, status: res.status, data: JSON.parse(text) };
  } catch {
    return { ok: res.ok, status: res.status, data: { error: text } };
  }
}

export const api = {
  get:  (path)       => req('GET',  path),
  post: (path, body) => req('POST', path, body),

  me:           ()      => api.get('/api/me'),
  todaySummary: ()      => api.get('/api/today-summary'),
  signinsToday: ()      => api.get('/api/signins/today'),
  submitSignin: (data)  => api.post('/api/submit-signin', data),
  undoSignin:   ()      => api.post('/api/undo-last-signin', {}),
  departure:    (id)    => api.post(`/api/signin/${id}/departure`, {}),
  updateMembers:(id, n) => api.post(`/api/signin/${id}/update-members`, { member_people: n }),
  updateGuests: (id, swimmers, nonSwimmers, under2) =>
    api.post(`/api/signin/${id}/update-guests`, {
      guest_swimmers:     swimmers,
      guest_non_swimmers: nonSwimmers,
      guest_under_2:      under2,
    }),
  scanQR:           (p)     => api.post('/api/scan-qr', { payload: p }),
  scanLicense:      (p)     => api.post('/api/scan-license', { payload: p }),
  recordGuestVisit: (signinId, guestId, memberNum) => api.post('/api/record-guest-visit', { signin_id: signinId, guest_id: guestId, membership_number: memberNum }),
  signinGuests: (signinId) => api.get(`/api/signins/${signinId}/guests`),
  memberLookup: (q)     => api.get(`/api/member-lookup?q=${encodeURIComponent(q)}`),
  memberHistory:(num)   => api.get(`/api/member-history/${num}`),
  suggestedImportStart: () => api.get('/api/membership-import/suggested-start'),

  flaskUrl: (path) => `${BASE}${path}`,
};
